export const megabyte = 1000000;

export const contractStatuses = {
  freelancerApply: 'freelancer apply',
  created: 'created',
};

export const modalTemplates = {
  signUp: 'sign-up',
  enterCode: 'enter-code',
  requestDemo: 'request-demo',
  contactSupport: 'contact-support',
};

export const signInTemplates = {
  signInEmail: 'sign-in-email',
  signInPassword: 'sign-in-password',
};

export const skillsCategories = {
  tax: 'Tax',
  accounting: 'Accounting',
  audit: 'Audits',
  bookkeeping: 'Bookkeeping',
  software: 'Accounting Software',
  firmSoftware: 'Firm Software',
};

export const calendlyEvents = {
  event_type_viewed: 'calendly.event_type_viewed',
  date_and_time_selected: 'calendly.date_and_time_selected',
  event_scheduled: 'calendly.event_scheduled',
};

export const timesheetStatuses = {
  saved: 'saved',
  paid: 'paid',
  rejected: 'rejected',
  submitted: 'submitted',
  edited: 'edited',
  approved: 'approved',
};

export const roles = {
  admin: 'admin',
  client: 'client',
  freelancer: 'freelancer',
};

export const scopes = {
  admin: 'admin',
  client: 'client',
  freelancer: 'freelancer',
};

export const errors = {
  access_restricted: {
    code: 'access_restricted',
    message: 'Access is restricted',
  },
};
